import { autoinject } from "aurelia-dependency-injection";
import { BindingSignaler } from "aurelia-templating-resources";
import { bindable } from "aurelia-framework";
import { computedFrom } from "aurelia-framework";
import { DialogClientService } from "../../services/basic/dialog-client.service";
import { Reflection } from "../../helpers/reflection";

//Load styles
require("./comp-dialog.scss");

@autoinject
export class CompDialog {

    public showCloseButton: boolean;
    public dialogs: DialogItem[] = [];
    public dialogElements: HTMLElement[] = [];

    @bindable
    public key: string = "default";

    constructor(private bindingSignaler: BindingSignaler, private dialogClient: DialogClientService) { }

    public bind(): void {
        this.dialogClient.subscribeShow(this.showDialogueCallback, this.key);
        this.dialogClient.subscribeHide(this.hideDialogueCallback, this.key);
        document.addEventListener('keydown', this.onEsc);
    }

    public unbind(): void {
        this.dialogClient.unSubscribeShow(this.showDialogueCallback, this.key);
        this.dialogClient.unSubscribeHide(this.hideDialogueCallback, this.key);
        document.removeEventListener('keydown', this.onEsc);
    }

    public onEsc = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            this.hideModal(false);
        }
    }

    public showDialogueCallback: (view, model, showCloseButton, fullscreen, classList: string, scrollEntireDialog: boolean) => 
        void = (view, model, showCloseButton, fullscreen, classList: string, scrollEntireDialog: boolean) => {
        return new Promise<void>((resolve) => {
            const onElementSet = (element: Element) => {
                const animStarted = () => {
                    element.removeEventListener("animationend", animStarted, false);
                    element.classList.remove('au-enter-active');

                }
                element.classList.add('au-enter-active');
                element.addEventListener("animationend", animStarted, false);
                resolve();
            }
            this.dialogs.push(new DialogItem(view, model, classList, onElementSet, fullscreen, showCloseButton, scrollEntireDialog));
            this.bindingSignaler.signal("update-class-dialog");
        });
    }

    public hideDialogueCallback: (view, model) => void = () => {
        return new Promise<void>((resolve) => {
            if (this.dialogs.length > 0) {
                const last = this.dialogs[this.dialogs.length - 1].element;
                const animEnded = () => {
                    this.dialogs.pop();
                    resolve();
                };
                if (last) {
                    last.classList.add('au-leave-active');
                    last.addEventListener("animationend", animEnded, false);
                } else {
                    animEnded();
                }

                //For mobile and tablets hide the keyboard to avoid an issue with ios that keeps the keyboard opened
                if (document.activeElement) {
                    (<any>document.activeElement).blur();
                }
            } else {
                resolve();
            }
        });
    }

    public hideModal(forceClose: boolean) {
        this.dialogClient.hide(forceClose, this.key);
    }
}

export class DialogItem {

    _element: Element;

    constructor(public view: string, public model: any, public classList: string, private onElementSet: (element: Element) => void,
        public fullscreen: boolean, public showCloseButton: boolean, public scrollEntireDialog: boolean) { }

    @computedFrom(Reflection.getPropertyPath<DialogItem>(z => z._element))
    set element(value: Element) {
        this._element = value;
        if (value) {
            this.onElementSet(value);
        }
    }

    get element(): Element {
        return this._element;
    }
}
